import balanceText from 'balance-text'
import PropTypes from 'prop-types'
import React, { useLayoutEffect, useRef } from 'react'
import { isSSR } from 'js/isSSR'

const ActualBalanceText = ({ children }) => {
  const ref = useRef()

  // Ensure we always throw away the span and render a new one
  // if something changes, or else we could end up with duplicate
  // content in the span.
  const key = Date.now()

  useLayoutEffect(() => {
    balanceText(ref.current, { watch: true })
    // FIXME: dont ignore
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref.current])

  if (React.Children.count(children) === 1) {
    return React.cloneElement(React.Children.only(children), { ref, key })
  }

  return (
    <span ref={ref} key={key}>
      {children}
    </span>
  )
}

ActualBalanceText.propTypes = {
  children: PropTypes.any,
}

const BalanceText = ({ children }) => {
  if (isSSR) {
    return children
  }

  return <ActualBalanceText>{children}</ActualBalanceText>
}

BalanceText.propTypes = {
  children: PropTypes.any,
}

export default BalanceText
